import React from 'react';
import { i18n } from 'i18next';
import { Channel } from 'packages/lane-shared/types/ChannelType';
import { DraftContentType } from 'lane-shared/types/content/DraftContent';
import { ContentType } from 'lane-shared/types/content/Content';
import { WhiteLabelType } from 'lane-shared/types/WhiteLabelType';
import { colorToHex } from 'lane-shared/helpers/formatters';

const HERO_ICON =
  'https://lane-media-prd-us-east-2.s3.us-east-2.amazonaws.com/pen-to-square.png';

type PreviewHeroCardProps = {
  content: DraftContentType | ContentType;
  subject?: string;
  whiteLabel: WhiteLabelType;
  channel: Channel;
  i18n: i18n;
  isSurvey?: boolean;
};

/**
 * Fixed, non-editable hero block for the V2 interaction receipt preview.
 * Mirrors `renderHeroCard` in EmailUserContentInteractionReceiptV2: it is a
 * structural element, not the editable Intro or Body box.
 */
export function PreviewHeroCard({
  content,
  subject,
  whiteLabel,
  channel,
  i18n,
  isSurvey = false,
}: PreviewHeroCardProps) {
  const brandName = whiteLabel?.name || channel.name;
  const primaryColor =
    colorToHex(whiteLabel?.profile?.backgroundColor) || '#4837B9';

  const descriptionKey = isSurvey
    ? 'shared.email.userContentReceiptInteraction.description'
    : 'shared.email.userContentInteractionStatusChange.description';
  const ctaText = isSurvey
    ? i18n.t('shared.email.viewResponse.text')
    : i18n.t('View');

  return (
    <div style={{ padding: '16px 0', width: '100%' }} data-test="heroCard">
      <div
        style={{
          width: 69,
          height: 69,
          borderRadius: 12,
          backgroundColor: '#E8EDF3',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
        }}
      >
        <img src={HERO_ICON} alt="update icon" width={32} height={32} />
      </div>
      <div style={{ fontWeight: 'bold', fontSize: 18, marginBottom: 8 }}>
        {subject ?? content.name}
      </div>
      <div style={{ color: '#72777E', fontSize: 14, marginBottom: 8 }}>
        {i18n.t(descriptionKey, {
          contentName: content.name,
        })}
      </div>
      <div style={{ color: '#72777E', fontSize: 14, marginBottom: 16 }}>
        {i18n.t('shared.onboarding.invite.email.fullDetails')}{' '}
        <a
          href={whiteLabel.baseUrl}
          style={{
            color: primaryColor,
            textDecoration: 'underline',
            fontWeight: 500,
          }}
        >
          {brandName}
        </a>
      </div>
      <div
        style={{
          backgroundColor: primaryColor,
          color: '#FFFFFF',
          borderRadius: 24,
          padding: '14px 12px',
          textAlign: 'center',
          fontWeight: 600,
          fontSize: 17,
          cursor: 'default',
        }}
      >
        {ctaText}
      </div>
    </div>
  );
}
